import type { RankingTable } from '../types';
import { richTextToPlainText } from '../utils/richText';
import { uniqueKeys } from '../utils/uniqueKeys';
import { RichText } from './RichText';
import { ScrollableTable } from './ScrollableTable';

const HEADER_CELL_CLASS = 'p-3 text-xs font-semibold uppercase tracking-wider text-secondary-500';

export const EditorialTable = (props: RankingTable) => {
  const { caption, columns, rows } = props;
  const columnKeys = uniqueKeys(columns);
  const rowKeys = uniqueKeys(rows.map((row) => row.header ?? row.cells.map(richTextToPlainText).join('|')));
  const hasUnlabelledHeaderColumn =
    rows.some((row) => row.header != null) && rows.every((row) => row.cells.length === columns.length);

  return (
    <ScrollableTable>
      <table className="w-full min-w-[560px] text-left text-sm text-secondary-700">
        {caption != null ? <caption className="sr-only">{caption}</caption> : null}
        <thead className="bg-secondary-50">
          <tr>
            {hasUnlabelledHeaderColumn ? <th scope="col" className={HEADER_CELL_CLASS} /> : null}
            {columns.map((column, index) => (
              <th key={columnKeys[index]} scope="col" className={HEADER_CELL_CLASS}>
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-secondary-200">
          {rows.map((row, rowIndex) => {
            const cellKeys = uniqueKeys(row.cells.map(richTextToPlainText));

            return (
              <tr key={rowKeys[rowIndex]}>
                {row.header != null ? (
                  <th scope="row" className="p-3 align-top font-semibold text-secondary-950">
                    {row.header}
                  </th>
                ) : null}
                {row.cells.map((cell, cellIndex) => (
                  <td key={cellKeys[cellIndex]} className="p-3 align-top">
                    {typeof cell === 'string' ? cell : <RichText text={cell} />}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </ScrollableTable>
  );
};
